import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tutor-card-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="w-full border border-gray_1 shadow-[0px_1px_3px_0px_#00000014] p-5 rounded-lg bg-white select-none">
      <div class="flex flex-wrap md:flex-nowrap space-y-5 md:space-y-0 md:space-x-5">
        <!-- Left Section (Image & Action Buttons) -->
        <div class="md:max-w-[290px] w-full space-y-5">
          <!-- Tutor Image Placeholder -->
          <div class="w-full h-[180px] bg-gray_9 animate-pulse rounded-md"></div>
          <!-- Action Buttons Placeholder -->
          <div class="w-full space-y-2.5">
            <div class="w-full h-10 bg-gray_9 animate-pulse rounded-lg"></div>
            <div class="w-full h-10 bg-gray_6 animate-pulse rounded-lg"></div>
          </div>
        </div>

        <!-- Right Section (Details) -->
        <div class="w-full space-y-5">
          <!-- Top Info Bar -->
          <div class="w-full flex justify-between items-start">
            <div class="flex items-center">
              <!-- Avatar Placeholder -->
              <div class="w-12 h-12 rounded-full bg-gray_9 animate-pulse shrink-0"></div>
              
              <div class="ml-2.5 space-y-2">
                <!-- Name Block -->
                <div class="w-48 h-6 bg-gray_9 animate-pulse rounded-md"></div>
                
                <!-- Location, Rating, Save Info -->
                <div class="flex items-center space-x-4">
                  <div class="w-32 h-4 bg-gray_9 animate-pulse rounded-md"></div>
                  <div class="w-16 h-4 bg-gray_9 animate-pulse rounded-md"></div>
                  <div class="w-12 h-4 bg-gray_9 animate-pulse rounded-md"></div>
                </div>
              </div>
            </div>

            <!-- Pricing Block -->
            <div class="space-y-1 text-right">
              <div class="w-20 h-4 bg-gray_6 animate-pulse rounded-md ml-auto"></div>
              <div class="w-24 h-6 bg-gray_9 animate-pulse rounded-md ml-auto"></div>
            </div>
          </div>

          <!-- Availability Row -->
          <div class="w-full space-y-2">
            <div class="w-24 h-4 bg-gray_9 animate-pulse rounded-md"></div>
            <div class="flex flex-wrap gap-2">
              <div *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]" class="w-12 h-8 bg-gray_6 animate-pulse rounded-md"></div>
            </div>
          </div>

          <!-- Subject Tags -->
          <div class="w-full flex flex-wrap gap-2">
            <div *ngFor="let i of [1, 2, 3]" class="w-20 h-6 bg-gray_6 animate-pulse rounded-md"></div>
          </div>

          <!-- Bio/Description lines -->
          <div class="w-full space-y-2">
            <div class="w-full h-4 bg-gray_6 animate-pulse rounded-md"></div>
            <div class="w-5/6 h-4 bg-gray_6 animate-pulse rounded-md"></div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class TutorCardSkeletonComponent {}
